import { __makeTemplateObject } from "tslib";
import { css } from 'emotion';
export var getSegmentStyles = function (theme) {
    return {
        segment: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      cursor: pointer;\n      width: auto;\n    "], ["\n      cursor: pointer;\n      width: auto;\n    "]))),
        queryPlaceholder: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), theme.palette.gray2),
        disabled: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      cursor: not-allowed;\n      opacity: 0.65;\n      box-shadow: none;\n    "], ["\n      cursor: not-allowed;\n      opacity: 0.65;\n      box-shadow: none;\n    "]))),
    };
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=styles.js.map